// extracted by mini-css-extract-plugin
export default {"count":"RecommendationsCount_count__LQT4U"};